export const environment = {
  production: true,
  apiUrl: "https://stg-smp-eu-west-1.service.3ddigitalvenue.com/tmp",
  routes: true,
};
